import React from 'react';
export function LocationCards() {
  const locations = [{
    city: 'Miami',
    revenue: '$123k',
    status: 'active',
    statusColor: 'text-[#4ac88a]',
    top: false
  }, {
    city: 'Houston',
    revenue: '$185k',
    status: 'top city',
    statusColor: 'text-[#b8a06a]',
    top: true
  }, {
    city: 'Las Vegas',
    revenue: '$156k',
    status: 'active',
    statusColor: 'text-[#b8a06a]',
    top: false
  }, {
    city: 'Phoenix',
    revenue: '$115k',
    status: 'active',
    statusColor: 'text-[#b8a06a]',
    top: false
  }];
  return <div className="grid grid-cols-4 gap-6 mb-6" data-id="element-61">
      {locations.map(loc => <div key={loc.city} className={`bg-[#060c18] border border-[#0e1826] rounded-xl p-6 flex flex-col items-center justify-center text-center relative overflow-hidden ${loc.top ? 'border-t-2 border-t-[#b8a06a]' : ''}`} data-id="element-62">
          <span className="text-xs font-semibold text-[#3a5070] tracking-wider uppercase mb-2" data-id="element-63">
            {loc.city}
          </span>
          <span className="text-3xl font-bold text-[#f0ead8] mb-2" data-id="element-64">
            {loc.revenue}
          </span>
          <span className={`text-xs font-medium ${loc.statusColor}`} data-id="element-65">
            {loc.status}
          </span>
        </div>)}
    </div>;
}